// app/classeDoc/classi.js

(function () {
    'use strict';
    var controllerId = 'classeDoc';
    angular.module('app').controller(controllerId, ['common', '$rootScope', '$location', 'bootstrap.dialog', '$routeParams', '$uibModal', '$filter', 'datacontext', 'sectionMenu', 'filterFilter', '$translate', '$timeout', classeDoc]);

    function classeDoc(common, $rootScope, $location, bDialog, $routeParams, $uibModal, $filter, datacontext, sectionMenu, filterFilter, $translate, $timeout) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Classi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "ClasseDoc"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !$rootScope.licenzaValida;
        vm.addTitle = $translate.instant('NuovaClasse');
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        //Elenco per Ordinamento
        vm.list = {};        
        vm.list.ordine = ['Classe', 'Codice'];
        if (!vm.super)
            vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[1];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Gestione Attach
        vm.fAttach = {};
        vm.filterAttach = '';
        vm.setfAttach = setfAttach;
        vm.list.attach = [];
        vm.getListAttach = getListAttach;
        vm.tSourceCode_def = 'CLS';
        vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;

        //Elenchi dettaglio
        vm.list.studenti = [];

        vm.getRecord = getRecord;
        vm.getListStudenti = getListStudenti;

        //Filtro
        vm.filter = {};
        vm.filter.anno = -1;
        vm.filter.classe = '';

        //Pannello Sessioni
        //vm.activated = false;
        vm.loadMoreSessioni = getAllSessioniClasseByFilter;
        vm.loadAllSessioni = getAllSessioniClasse;
        vm.pageSessioni = 1;
        vm.mySessions = true;
        vm.fAnnoSessioni = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.countRecordsSessioni = 0;
        vm.sessioniClasse = [];
        vm.filter.ricerca = '';
        vm.filter.docenteId = $rootScope.id;
        vm.cercaSessioni = cercaSessioni;
        vm.goSession = goSession;       
        vm.mostraCodice = mostraCodice;

        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;
                        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;        
        vm.add = addModal;
        vm.delete = deleteItem;
        vm.deleteStudente = deleteStudente;
        vm.addStudente = addStudente;

        vm.cercaSessioni = cercaSessioni;

        //Elenchi dettaglio
        vm.listSessioni = {};
        vm.listSessioni.ordine = ['Test', 'Materia', 'Docente', 'Effettuato'];
        vm.listSessioni.ordine = common.setOrdine(vm.listSessioni.ordine);

        vm.ordineSessioni = vm.listSessioni.ordine[3];
        vm.selectOrdineSessioni = function (item) {
            vm.ordineSessioni = item;
            cercaSessioni();
        };

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getTSource(vm.tSourceCode_def), getTAttach(vm.tSourceCode_def)];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.ClasseId != null) {
                            setView('detail');
                            getRecord($routeParams.ClasseId, 0);
                        }

                    });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;
            vm.filter.classe = vm.fClasse == null ? '' : vm.fClasse;            

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.classe_countAll(vm.filter.anno, vm.filter.classe)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;            
            return datacontext.classe_getAll(vm.pageSize, vm.page, vm.filter.anno, vm.filter.classe, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.classe_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.record.Anno = $filter('annoClasse')(vm.record.Anno);                
                vm.list.studenti = getListStudenti(id);
                vm.list.attach = getListAttach(id);
                vm.performanceMaterie = getPerformanceStudenteMaterie(id);

                $timeout(function () {
                    setView('detail');
                }, 200);
            });
        }            

        //List Methods       
        function getListStudenti(id) {
            if (!id) return;
                        
            return datacontext.studente_getAllByClasse(id).then(function (data) {               
                return vm.list.studenti = data;
            });
        }

        //Metodi modale
        function addModal() {
            datacontext.indirizzo_getAllList().then(function (data) {
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/classeDoc/modal/classeDocAdd.html?version=43',
                    controller: 'classeDocAdd',
                    resolve: {
                        indirizzi: function () {
                            return data;
                        },
                        anno: function () {
                            return vm.fAnno;
                        },
                        societaId: function () {
                            return $rootScope.societa.Id;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (!returnItem) return logError($translate.instant('ErroreCreazione'));
                    logSuccess($translate.instant('DatoSalvato'));
                    cerca();
                    var classeId = returnItem.Id || returnItem;
                    datacontext.classe_get(classeId).then(function (classe) {
                        mostraCodice(classe);
                    });
                });
            });
        }

        function deleteItem(item) {
            var msg = ' ' + $translate.instant('classe') + ' ' + item.classe;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.classe_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        function deleteStudente(studente) {

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/classeDoc/modal/eliminazioneAllievo.html?version=43',
                controller: 'eliminazioneAllievo',
                resolve: {
                    studente: function () {
                        return studente;
                    },
                    classe: function () {
                        return vm.record.classe;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                return datacontext.studente_classeDelete(studente.Id, vm.record.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));
                    else {
                        logSuccess($translate.instant('AllievoEliminato'));
                        getRecord(vm.record.Id, vm.index);
                    }
                });
            });           
        }

        // Studente
        function addStudente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/classeDoc/modal/classeStudenteDocAdd.html?version=43',
                controller: 'classeStudenteDocAdd',
                resolve: {
                    classe: function () {
                        return vm.record;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getListStudenti(vm.record.Id);
                logSuccess($translate.instant('DatoSalvato'));
            });
        }

        //Gestione Attach
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAll(0, 0, vm.tSourceCode_def, 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                return vm.list.attach = data;
            });
        }

        function addAttach(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name }
            var recSource = { Id: vm.record.Id, Name: vm.record.Cognome + ' ' + vm.record.Nome }

            var modalInstance = $uibModal.open({
                templateUrl: '/app/attach/modal/attachAdd.html?version=43',
                controller: 'attachAdd',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError($translate.instant('ErroreFormato'));
                if (returnItem == "400") return logError($translate.instant('ErroreRegistrazione')) + '[' + returnItem + ']';//('Errore registrazione dati [' + returnItem + ']');

                logSuccess($translate.instant('DatoSalvato'));
                getListAttach(vm.record.Id);
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function deleteAttach(item) {
            var msg = ' ' + $translate.instant('Allegato') + ' ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError($translate.instant('AttenzioneAllegato'));

                    var index = vm.list.attach.indexOf(item)
                    vm.list.attach.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }

        function cercaSessioni() {
            vm.sessioniClasse  = [];
            vm.countRecordsSessioni = 0;
            vm.pageSessioni = 1;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            if (vm.mySessions)
                vm.filter.docenteId = $rootScope.id;
            else
                vm.filter.docenteId = 0;
            vm.loading = false;
            return getAllSessioniClasseByFilter();
        }

        function countSessioniClasseByFilter() {
            return datacontext.reportClasseSession_countAllByClasseId(vm.record.Id, vm.filter.ricerca, vm.filter.docenteId).then(function (data) {
                if (data) {
                    vm.countRecordsSessioni = data;
                }
            });
        }

        function getAllSessioniClasseByFilter() {
            //if (!vm.activated) return;
            if (vm.loading === true) return;
            if (vm.countRecordsSessioni == 0) countSessioniClasseByFilter();
            else if (vm.countRecordsSessioni <= vm.sessioniClasse.length) return;

            vm.loading = true;
            return datacontext.reportClasseSession_getAllByClasseId(vm.pageSize, vm.pageSessioni, vm.record.Id, vm.filter.ricerca, vm.filter.docenteId, vm.ordineSessioni.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.pageSessioni++;
                    data.forEach(function (item) {
                        vm.sessioniClasse.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAllSessioniClasse() {
            if (vm.sessioniClasse.length < vm.countRecordsSessioni) {
                getAllSessioniClasseByFilter().then(function () { getAllSessioniClasse(); });
            }
        }

        function goSession(sessionId) {
            $location.path('/EDUP_session/' + sessionId);
        }

        function getPerformanceStudenteMaterie(id) {
            vm.performanceMaterie = [];
            return datacontext.performanceMateria_getAll(vm.fAnnoSessioni, id, 0).then(function (data) {                
                vm.performanceMaterie = data;
            });
        }

        function mostraCodice(classe) {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/classeDoc/modal/codiceClasse.html?version=43",
                controller: "codiceClasse",                
                resolve: {
                    classe: function () {
                        return classe;
                    }
                }
            });
        }
    }
})();
